module.exports = __webpack_public_path__ + "img/11.06d8cc33.png";